import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberLocation } from '../../../../core/services/member.service';
import { LocationPickerComponent } from '../location-picker/location-picker.component';

/**
 * Modal wrapper around the Leaflet location picker. Holds a draft of the picked
 * location and only emits it back to the parent on confirm, so the map can be
 * cancelled without touching the form. Stacks above the member modal (z-[70]).
 */
@Component({
  selector: 'app-location-picker-modal',
  standalone: true,
  imports: [CommonModule, LocationPickerComponent],
  templateUrl: './location-picker-modal.component.html'
})
export class LocationPickerModalComponent implements OnChanges {
  @Input() open = false;
  @Input() value: MemberLocation | null = null;

  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<MemberLocation | null>();

  draft: MemberLocation | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    // Seed the draft from the current value each time the modal opens.
    if (changes['open'] && this.open) {
      this.draft = this.value ? { ...this.value } : null;
    }
  }

  onDraftChange(value: MemberLocation | null): void {
    this.draft = value;
  }

  cancel(): void { this.closed.emit(); }

  confirm(): void {
    this.confirmed.emit(this.draft);
  }
}
